function showTabOnClick() {
    const tabContainerElements = document.querySelectorAll('.tabs');

    if (!tabContainerElements) {
        return;
    }

    tabContainerElements.forEach((tabContainer) => {
        const tabLinks = tabContainer.querySelectorAll('.tabs__tab-link');
        const tabContents = tabContainer.querySelectorAll('.tab-contents');
        const mobileTabTitle = tabContainer.querySelector('.tabs-indicators--mobile .tab-button__text');
        const mobileTabWrapper = tabContainer.querySelector('.tabs-indicators__wrapper');

        if (tabContents[0]) {
            tabContents[0].style.display = 'block';
            tabLinks[0].classList.add('tabs__tab-link--active');
            mobileTabTitle.innerText = tabLinks[0].querySelector('.tabs__tab-title').innerText;
        }
        tabLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                const target = link.href.split('#')[1];

                if (!target) {
                    return;
                }

                tabContents.forEach((tabContent) => {
                    if (tabContent.getAttribute('id') === target) {
                        tabContent.style.display = 'block';
                    } else {
                        tabContent.style.display = 'none';
                    }
                });

                tabLinks.forEach((otherLink) => {
                    otherLink.classList.toggle('tabs__tab-link--active', link.href === otherLink.href);
                });

                mobileTabTitle.innerText = link.querySelector('.tabs__tab-title').innerText;

                const onMobile = window.matchMedia('(max-width: 768px)').matches;
                if (onMobile && !mobileTabWrapper.classList.contains('tabs-indicators__wrapper--hidden')) {
                    mobileTabWrapper.classList.add('tabs-indicators__wrapper--hidden');
                    const mobileTabButton = tabContainer.querySelector('.tabs-indicators--mobile .tab-button');
                    mobileTabButton.classList.remove('active');
                }
            });
        });

        const onMobile = window.matchMedia('(max-width: 768px)').matches;

        if (onMobile) {
            mobileTabWrapper.classList.add('tabs-indicators__wrapper--hidden');

            const mobileTabButton = tabContainer.querySelector('.tabs-indicators--mobile .tab-button');
            mobileTabButton.addEventListener('click', () => {
                mobileTabWrapper.classList.toggle('tabs-indicators__wrapper--hidden');
                mobileTabButton.classList.toggle('active');
            });
        }
    });
}

showTabOnClick();
